import { Box } from '@mui/material'
import Add from '@mui/icons-material/Add'
import { AppButton } from '../../../../components/UI'
import React, { useEffect, useState } from 'react'
import CustomAutoComplete from '../../../../common/CustomAutoComplete'
import { getUserData, updateObjectStateValue } from '../../../../utils/FunctionHelpers'
import { withSnackbar } from '../../../../utils/SnackbarHOC'
import SelectionModal from '../../../Dashboard/Modals/SelectionModal'
import { getAllCadidatSelections } from '../../../../services/SelectionCandidatService'

const Step1 = ({ importData, errors, setImportData, snackbarShowMessage }) => {
    const [selectionData, setSelectionData] = useState({
        isLoading: false,
        data: [],
        label: "SELECTION",
        required: true
    })
    const [reloadSelections, setReloadSelections] = useState(false)

    const handleChange = (event) => {
        setImportData((prevState) => ({
            ...prevState,
            [event.target.name]: event.target.value
        }))
    }

    const handleSelectionChange = (selection) => {
        handleChange({
            target: {
                name: 'selection',
                value: selection
            }
        })
    }

    const loadSelections = () => {
        updateObjectStateValue(
            setSelectionData,
            { isLoading: true, data: [] }
        )
        getAllCadidatSelections('?archived=false').then(({ data }) => {
            updateObjectStateValue(
                setSelectionData,
                { isLoading: false, data: data.candidatsSelections }
            )
        }).catch(() => {
            snackbarShowMessage("Erreur de chargement des sélections.", "error", 4000)
        }).finally(() => {
            updateObjectStateValue(
                setSelectionData,
                { isLoading: false }
            )
        })
    }

    useEffect(() => {
        loadSelections()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reloadSelections])

    return (
        <>
            {
                getUserData().role.includes('ROLE_DIRECTION')
                && (
                    <SelectionModal {...{ selectedCandidats: [], snackbarShowMessage, isImport: true, setReloadSelections, reloadSelections, setImportData }}>
                        {(handleOpen) => (
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: -1 }}>
                                <AppButton variant="ghost" size="small" startIcon={<Add fontSize="small" />} onClick={() => handleOpen()}>
                                    Créer une nouvelle sélection
                                </AppButton>
                            </Box>
                        )}
                    </SelectionModal>
                )
            }
            <CustomAutoComplete disablePortal={false} style={{marginBottom:  "10px"}} listData={selectionData} errors={errors} value={importData.selection} handleDataChange={handleSelectionChange} name="selection" />
        </>
    )
}

export default withSnackbar(Step1)
